export const formatTime = (time: number, onlyMinutes = false): string => {
	if (!time) {
		return '0:00';
	}
	const minutes = Math.floor(time / 60);

	if (onlyMinutes) {
		return minutes.toString();
	}

	const seconds: string = (() => {
		const s = Math.floor(time - minutes * 60);
		return s < 10 ? `0${s}` : s.toString();
	})();
	return `${minutes}:${seconds}`;
};

export interface GuideDuration {
	unit: 'minutes' | 'seconds';
	value: number;
}

const SECONDS_PER_MINUTE = 60;

// Both phone apps round a track's length to the nearest minute and only state it in seconds
// when the track runs under one (Android's DateTimeUtils bumps the minute once the leftover
// seconds reach 30; iOS rounds seconds/60). The wire sends fractional seconds — 604.81 for a
// ten-minute session — so the rounding direction is visible in the label, and truncating
// instead would read a minute short on most of the catalogue. The sub-minute branch truncates
// rather than rounds, since rounding a 59.6s track up would render it as "60 sec".
export const roundGuideDuration = (seconds: number): GuideDuration => {
	if (seconds < SECONDS_PER_MINUTE) {
		return { unit: 'seconds', value: Math.floor(seconds) };
	}

	return { unit: 'minutes', value: Math.round(seconds / SECONDS_PER_MINUTE) };
};
